import { Link } from "react-router-dom";

const VARIANTS = {
  primary: "bg-[#FF5500] text-white hover:bg-[#FF6B1A] shadow-[0_0_24px_rgba(255,85,0,0.28)]",
  ghost: "border border-white/15 text-slate-100 hover:bg-white/5 hover:border-white/30",
};

export const CtaLink = ({ to, children, variant = "primary", testId, className = "", ...rest }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex min-h-[44px] items-center gap-2 rounded-lg px-6 py-3 text-sm font-bold uppercase tracking-wider transition-[background-color,border-color,transform] duration-200 active:scale-[0.98] focus-ring ${VARIANTS[variant]} ${className}`}
    {...rest}
  >
    {children}
  </Link>
);
